export class ImagesModel{
    id?: number;
    eventWorldId?: number;
    imageURL?:string;
    isMainImage?:boolean;
    
   


    constructor(item?:ImagesModel){
        item = item? item:{};
        this.id = item.id? item.id:0;
        this.eventWorldId = item.eventWorldId? item.eventWorldId:0;
        this.imageURL = item.imageURL? item.imageURL:'';
        this.isMainImage = item.isMainImage? item.isMainImage:false;
     
        
    
    }

}